import { Jugador, JugadorJSON } from '../Jugador/Jugador';
import {
  AperturaAptoFisicoXTemporada,
  AperturaAptoFisicoXTemporadaJSON,
} from '../AperturaAptoFisicoXTemporada/AperturaAptoFisicoXTemporada';
export interface AptoFisicoJSON {
  apf_id: string;
  apf_jugid: string;
  apf_fecha: Date | null;
  apf_nombre: string;
  apf_apellido: string;
  apf_email: string;
  apf_telefono: string;
  apf_selfie: string;
  apf_selfie_filetype: string;
  apf_comprobante_medico: string;
  apf_comprobante_medico_filetype: string;
  apf_usid_aprobacion: number;
  apf_aprobado: boolean;
  apf_fecha_evaluacion: Date | null;
  apf_aafxtid: string;
  jugador: JugadorJSON | null;
  aperturaAptoFisicoXTemporada: AperturaAptoFisicoXTemporadaJSON | null;
}

export class AptoFisico {
  protected constructor(
    private id: string,
    private jugid: string,
    private fecha: Date | null,
    private nombre: string,
    private apellido: string,
    private email: string,
    private telefono: string,
    private selfie: string,
    private selfieFiletype: string,
    private comprobanteMedico: string,
    private comprobanteMedicoFiletype: string,
    private usidAprobacion: number,
    private aprobado: boolean,
    private fechaEvaluacion: Date | null,
    private aafxtid: string,
    private jugador: Jugador | null,
    private aperturaAptoFisicoXTemporada: AperturaAptoFisicoXTemporada | null
  ) {}

  static build(
    jugador: Jugador,
    nombre: string,
    apellido: string,
    email: string,
    telefono: string,
    apertura: AperturaAptoFisicoXTemporada,
    fileComprobanteMedico: File,
    fileSelfie: File | null
  ): AptoFisico {
    return new this(
      '',
      jugador.getId()!,
      null,
      nombre,
      apellido,
      email,
      telefono,
      '',
      fileSelfie?.type ?? '',
      '',
      fileComprobanteMedico.type,
      0,
      false,
      null,
      apertura.getId()!,
      null,
      null
    );
  }

  static createFrom(
    id: string,
    jugid: string,
    fecha: Date | null,
    nombre: string,
    apellido: string,
    email: string,
    telefono: string,
    selfie: string,
    selfieFiletype: string,
    comprobanteMedico: string,
    comprobanteMedicoFiletype: string,
    usidAprobacion: number,
    aprobado: boolean,
    fechaEvaluacion: Date | null,
    aafxtid: string,
    jugador: Jugador | null,
    aperturaAptoFisicoXTemporada: AperturaAptoFisicoXTemporada | null
  ) {
    return new this(
      id,
      jugid,
      fecha,
      nombre,
      apellido,
      email,
      telefono,
      selfie,
      selfieFiletype,
      comprobanteMedico,
      comprobanteMedicoFiletype,
      usidAprobacion,
      aprobado,
      fechaEvaluacion,
      aafxtid,
      jugador,
      aperturaAptoFisicoXTemporada
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: AptoFisico) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: AptoFisicoJSON) {
    return AptoFisico.createFrom(
      entity.apf_id,
      entity.apf_jugid,
      entity.apf_fecha ? new Date(entity.apf_fecha) : null,
      entity.apf_nombre,
      entity.apf_apellido,
      entity.apf_email,
      entity.apf_telefono,
      entity.apf_selfie,
      entity.apf_selfie_filetype,
      entity.apf_comprobante_medico,
      entity.apf_comprobante_medico_filetype,
      entity.apf_usid_aprobacion,
      entity.apf_aprobado,
      entity.apf_fecha_evaluacion ? new Date(entity.apf_fecha_evaluacion) : null,
      entity.apf_aafxtid,
      entity.jugador ? Jugador.fromJSON(entity.jugador) : null,
      entity.aperturaAptoFisicoXTemporada
        ? AperturaAptoFisicoXTemporada.fromJSON(entity.aperturaAptoFisicoXTemporada)
        : null
    );
  }

  toJSON(): AptoFisicoJSON {
    return {
      apf_id: this.getId(),
      apf_jugid: this.getJugid(),
      apf_fecha: this.getFecha(),
      apf_nombre: this.getNombre(),
      apf_apellido: this.getApellido(),
      apf_email: this.getEmail(),
      apf_telefono: this.getTelefono(),
      apf_selfie: this.getSelfie(),
      apf_selfie_filetype: this.getSelfieFiletype(),
      apf_comprobante_medico: this.getComprobanteMedico(),
      apf_comprobante_medico_filetype: this.getComprobanteMedicoFiletype(),
      apf_usid_aprobacion: this.getUsidAprobacion(),
      apf_aprobado: this.getAprobado(),
      apf_fecha_evaluacion: this.getFechaEvaluacion(),
      apf_aafxtid: this.getAafxtid(),
      jugador: this.getJugador() ? this.getJugador()!.toJSON() : null,
      aperturaAptoFisicoXTemporada: null,
    };
  }

  getId(): string {
    return this.id;
  }

  getSelfieFiletype(): string {
    return this.selfieFiletype;
  }

  getComprobanteMedicoFiletype(): string {
    return this.comprobanteMedicoFiletype;
  }

  getJugid(): string {
    return this.jugid;
  }

  getFecha(): Date | null {
    return this.fecha;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getEmail(): string {
    return this.email;
  }

  getTelefono(): string {
    return this.telefono;
  }

  getSelfie(): string {
    return this.selfie;
  }

  getComprobanteMedico(): string {
    return this.comprobanteMedico;
  }

  getUsidAprobacion(): number {
    return this.usidAprobacion;
  }

  getAprobado(): boolean {
    return this.aprobado;
  }

  getFechaEvaluacion(): Date | null {
    return this.fechaEvaluacion;
  }

  getAafxtid(): string {
    return this.aafxtid;
  }

  getJugador(): Jugador | null {
    return this.jugador;
  }
  getAperturaAptoFisicoXTemporada(): AperturaAptoFisicoXTemporada | null {
    return this.aperturaAptoFisicoXTemporada;
  }
}
